// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-content-category {
    flex-grow: 1;
}

.category-form-container {
    border: 1px solid #ddd;
    padding: 30px;
    background-color: #fff;
    border-radius: 5px;
}

.form-row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.form-row:last-child {
    margin-bottom: 0;
}

.form-row label {
    width: 150px;
    font-weight: bold;
    font-size: 16px;
}

.category-selectors {
    display: flex;
    gap: 10px;
}

.category-selectors select {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 200px;
}

.form-row input[type="text"] {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 100%;
}

.form-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin: 30px 0;
}

.form-actions button {
    padding: 15px 30px;
    min-width: 120px;
    max-width: 200px;
    flex: 1 1;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    transition: background-color 0.2s ease;
}

.btn-back {
    background-color: #333;
    color: white;
}

.btn-back:hover {
    background-color: #555;
}

.btn-save {
    background-color: #e84118;
    color: white;
}

.btn-save:hover {
    background-color: #d73502;
}

.btn-save:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.category-list-container {
    margin-top: 40px;
}

.category-list-header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
}

.btn-excel {
    background-color: white;
    border: 1px solid #ccc;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
}

.category-list {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
    overflow: hidden;
}

.category-items {
    /* 카테고리 아이템 컨테이너 */
}

.category-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
    min-height: 50px;
    transition: all 0.2s ease;
}

.category-row:last-child {
    border-bottom: none;
}

/* 드래그 앤 드롭 스타일 */
.sortable-item {
    cursor: grab;
}

.sortable-item:active {
    cursor: grabbing;
}

.drag-handle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin-right: 10px;
    cursor: grab;
    color: #666;
    transition: color 0.2s ease;
}

.drag-handle:hover {
    color: #333;
}

.drag-handle:active {
    cursor: grabbing;
}

.drag-handle svg {
    width: 20px;
    height: 20px;
}

/* 드래그 중일 때 스타일 */
.sortable-item[data-is-dragging="true"] {
    opacity: 0.5;
    transform: rotate(5deg);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    z-index: 1000;
}

.main-category-row {
    background-color: #fff;
    border-bottom: 1px solid #ddd;
}

.main-category-row:hover {
    background-color: #f8f9fa;
}

.sub-category-row {
    background-color: #f9f9f9;
    padding-left: 40px;
    border-bottom: 1px solid #eee;
}

.sub-category-row:hover {
    background-color: #f0f0f0;
}

.category-info {
    display: flex;
    align-items: center;
    gap: 15px;
}

.category-number {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    background-color: #e84118;
    color: white;
    border-radius: 50%;
    font-size: 12px;
    font-weight: bold;
}

.category-name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
}

.category-status-badge {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 500;
}

.category-status-badge.status-active {
    background-color: #e8f5e9;
    color: #2e7d32;
}

.category-status-badge.status-inactive {
    background-color: #ffebee;
    color: #c62828;
}

.category-row.category-inactive {
    background-color: #f5f5f5;
    opacity: 0.85;
}

.category-row.category-inactive .category-name {
    color: #999;
}

.action-btn.action-inactive {
    color: #c62828;
}

.action-btn.action-active {
    color: #2e7d32;
}

.category-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #666;
    font-size: 12px;
}

.action-btn {
    cursor: pointer;
    color: #666;
    text-decoration: none;
    padding: 2px 4px;
    border-radius: 3px;
    transition: background-color 0.2s;
}

.action-btn:hover {
    background-color: #f0f0f0;
    color: #333;
}

.separator {
    color: #ccc;
    font-size: 12px;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: white;
    padding: 40px;
    border-radius: 10px;
    text-align: center;
    width: 500px;
}

.modal-content h3 {
    margin-top: 0;
    font-size: 24px;
}

.modal-content p {
    margin-bottom: 30px;
    font-size: 16px;
}

.modal-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
}

.modal-actions button {
    padding: 12px 24px;
    min-width: 100px;
    flex: 1 1;
    max-width: 150px;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.modal-actions button:first-child {
    background-color: #333;
    color: white;
    border: none;
}

.modal-actions button:first-child:hover {
    background-color: #555;
}

.delete-btn {
    background-color: #e84118 !important;
    color: white !important;
    border: none !important;
}

.delete-btn:hover {
    background-color: #d73502 !important;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .category-selectors select {
        width: 150px;
    }

    .form-actions button {
        width: 200px;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .form-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }
    
    .form-row label {
        width: 100%;
    }
    
    .category-selectors {
        flex-direction: column;
        width: 100%;
    }

    .category-selectors select {
        width: 100%;
    }

    .form-actions {
        flex-direction: column;
    }
    
    .form-actions button {
        width: 100%;
    }

    .category-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        padding: 15px;
    }
    
    .sub-category-row {
        padding-left: 30px;
    }
    
    .category-info {
        width: 100%;
    }
    
    .category-actions {
        width: 100%;
        justify-content: flex-end;
    }

    .modal-content {
        width: 90%;
        padding: 20px;
    }
    
    .modal-actions {
        flex-direction: column;
        gap: 10px;
    }
    
    .modal-actions button {
        width: 100%;
        max-width: none;
    }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/CategoryManagementPage.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,SAAO;IACP,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,YAAY;IACZ,uBAAuB;IACvB,yCAAyC;IACzC,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA,+BAA+B;AAC/B;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;AACJ","sourcesContent":[".admin-content-category {\n    flex-grow: 1;\n}\n\n.category-form-container {\n    border: 1px solid #ddd;\n    padding: 30px;\n    background-color: #fff;\n    border-radius: 5px;\n}\n\n.form-row {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.form-row:last-child {\n    margin-bottom: 0;\n}\n\n.form-row label {\n    width: 150px;\n    font-weight: bold;\n    font-size: 16px;\n}\n\n.category-selectors {\n    display: flex;\n    gap: 10px;\n}\n\n.category-selectors select {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    width: 200px;\n}\n\n.form-row input[type=\"text\"] {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    width: 100%;\n}\n\n.form-actions {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin: 30px 0;\n}\n\n.form-actions button {\n    padding: 15px 30px;\n    min-width: 120px;\n    max-width: 200px;\n    flex: 1;\n    border-radius: 5px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    border: none;\n    transition: background-color 0.2s ease;\n}\n\n.btn-back {\n    background-color: #333;\n    color: white;\n}\n\n.btn-back:hover {\n    background-color: #555;\n}\n\n.btn-save {\n    background-color: #e84118;\n    color: white;\n}\n\n.btn-save:hover {\n    background-color: #d73502;\n}\n\n.btn-save:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n.category-list-container {\n    margin-top: 40px;\n}\n\n.category-list-header {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 15px;\n}\n\n.btn-excel {\n    background-color: white;\n    border: 1px solid #ccc;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.category-list {\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    overflow: hidden;\n}\n\n.category-items {\n    /* 카테고리 아이템 컨테이너 */\n}\n\n.category-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 20px;\n    border-bottom: 1px solid #eee;\n    min-height: 50px;\n    transition: all 0.2s ease;\n}\n\n.category-row:last-child {\n    border-bottom: none;\n}\n\n/* 드래그 앤 드롭 스타일 */\n.sortable-item {\n    cursor: grab;\n}\n\n.sortable-item:active {\n    cursor: grabbing;\n}\n\n.drag-handle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    margin-right: 10px;\n    cursor: grab;\n    color: #666;\n    transition: color 0.2s ease;\n}\n\n.drag-handle:hover {\n    color: #333;\n}\n\n.drag-handle:active {\n    cursor: grabbing;\n}\n\n.drag-handle svg {\n    width: 20px;\n    height: 20px;\n}\n\n/* 드래그 중일 때 스타일 */\n.sortable-item[data-is-dragging=\"true\"] {\n    opacity: 0.5;\n    transform: rotate(5deg);\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n    z-index: 1000;\n}\n\n.main-category-row {\n    background-color: #fff;\n    border-bottom: 1px solid #ddd;\n}\n\n.main-category-row:hover {\n    background-color: #f8f9fa;\n}\n\n.sub-category-row {\n    background-color: #f9f9f9;\n    padding-left: 40px;\n    border-bottom: 1px solid #eee;\n}\n\n.sub-category-row:hover {\n    background-color: #f0f0f0;\n}\n\n.category-info {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n}\n\n.category-number {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    background-color: #e84118;\n    color: white;\n    border-radius: 50%;\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.category-name {\n    font-size: 14px;\n    color: #333;\n    font-weight: 500;\n}\n\n.category-status-badge {\n    font-size: 11px;\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-weight: 500;\n}\n\n.category-status-badge.status-active {\n    background-color: #e8f5e9;\n    color: #2e7d32;\n}\n\n.category-status-badge.status-inactive {\n    background-color: #ffebee;\n    color: #c62828;\n}\n\n.category-row.category-inactive {\n    background-color: #f5f5f5;\n    opacity: 0.85;\n}\n\n.category-row.category-inactive .category-name {\n    color: #999;\n}\n\n.action-btn.action-inactive {\n    color: #c62828;\n}\n\n.action-btn.action-active {\n    color: #2e7d32;\n}\n\n.category-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #666;\n    font-size: 12px;\n}\n\n.action-btn {\n    cursor: pointer;\n    color: #666;\n    text-decoration: none;\n    padding: 2px 4px;\n    border-radius: 3px;\n    transition: background-color 0.2s;\n}\n\n.action-btn:hover {\n    background-color: #f0f0f0;\n    color: #333;\n}\n\n.separator {\n    color: #ccc;\n    font-size: 12px;\n}\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background-color: white;\n    padding: 40px;\n    border-radius: 10px;\n    text-align: center;\n    width: 500px;\n}\n\n.modal-content h3 {\n    margin-top: 0;\n    font-size: 24px;\n}\n\n.modal-content p {\n    margin-bottom: 30px;\n    font-size: 16px;\n}\n\n.modal-actions {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n}\n\n.modal-actions button {\n    padding: 12px 24px;\n    min-width: 100px;\n    flex: 1;\n    max-width: 150px;\n    border-radius: 5px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n.modal-actions button:first-child {\n    background-color: #333;\n    color: white;\n    border: none;\n}\n\n.modal-actions button:first-child:hover {\n    background-color: #555;\n}\n\n.delete-btn {\n    background-color: #e84118 !important;\n    color: white !important;\n    border: none !important;\n}\n\n.delete-btn:hover {\n    background-color: #d73502 !important;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .category-selectors select {\n        width: 150px;\n    }\n\n    .form-actions button {\n        width: 200px;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .form-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 5px;\n    }\n    \n    .form-row label {\n        width: 100%;\n    }\n    \n    .category-selectors {\n        flex-direction: column;\n        width: 100%;\n    }\n\n    .category-selectors select {\n        width: 100%;\n    }\n\n    .form-actions {\n        flex-direction: column;\n    }\n    \n    .form-actions button {\n        width: 100%;\n    }\n\n    .category-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n        padding: 15px;\n    }\n    \n    .sub-category-row {\n        padding-left: 30px;\n    }\n    \n    .category-info {\n        width: 100%;\n    }\n    \n    .category-actions {\n        width: 100%;\n        justify-content: flex-end;\n    }\n\n    .modal-content {\n        width: 90%;\n        padding: 20px;\n    }\n    \n    .modal-actions {\n        flex-direction: column;\n        gap: 10px;\n    }\n    \n    .modal-actions button {\n        width: 100%;\n        max-width: none;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
